import { styled, TableBody, TableBodyProps } from "@mui/material";

export const TableTitle = styled(TableBody)<TableBodyProps>(({ theme }) => ({
  "&>tr>td": {
    fontWeight: theme.typography.fontWeightBold,
    paddingTop: theme.spacing(2),
    backgroundColor: "inherit !important",
  },
}));
export const RateTableHead = styled(TableBody)<TableBodyProps>(({ theme }) => ({
  "&>tr>td": {
    backgroundColor: theme.palette.grey["300"],
    fontWeight: theme.typography.fontWeightMedium,
  },
  "&>tr>td:first-of-type": {
    borderLeft: `1px solid ${theme.palette.grey["400"]}`,
  },
  "&>tr>td:last-of-type": {
    borderRight: `1px solid ${theme.palette.grey["400"]}`,
  },
}));
export const RateTableBody = styled(TableBody)<TableBodyProps>(({ theme }) => ({
  "&>tr>td": {
    borderBottom: "none",
    backgroundColor: `${theme.palette.background.paper} !important`,
  },
  "&>tr:first-of-type>td": {
    paddingTop: theme.spacing(1),
  },
  "&>tr:last-of-type>td": {
    paddingBottom: theme.spacing(1),
  },
  "&>tr:hover>td": {
    backgroundColor: `${theme.palette.custom.deepSpace[200]} !important`,
  },
  "&>tr>td:first-of-type": {
    borderLeft: `1px solid ${theme.palette.grey["400"]}`,
  },
  "&>tr>td:last-of-type": {
    borderRight: `1px solid ${theme.palette.grey["400"]}`,
  },
}));
export const RateTableFooter = styled(TableBody)<TableBodyProps>(({ theme }) => ({
  "&>tr>td": {
    borderTop: `1px solid ${theme.palette.grey["400"]}`,
    fontWeight: theme.typography.fontWeightBold,
    backgroundColor: theme.palette.background.paper,
  },
  "&>tr:hover>td": {
    backgroundColor: `${theme.palette.background.paper} !important`,
  },
  "&>tr>td:first-of-type": {
    borderLeft: `1px solid ${theme.palette.grey["400"]}`,
  },
  "&>tr>td:last-of-type": {
    borderRight: `1px solid ${theme.palette.grey["400"]}`,
  },
}));
